import { TypeOf, yup } from '@guiker/shared-framework'

export const consentSchema = yup.object({
  agreed: yup.boolean().required().oneOf([true]),
})

export type ConsentSchema = TypeOf<typeof consentSchema>
